import { cssGenerator, view, extensions, textFormatting } from '@yola/ws-sdk';
import constants from '../constants';

const { TEXT_INTENT_MODIFIER_PREFIX } = textFormatting.constants;
const { TEXT } = cssGenerator.constants.classNames;

const shouldShowClearTrigger = (element) => {
  const settings = extensions.accessors.getExtensionSettings(constants.common.SLUG);
  const selection = textFormatting.accessors.getAdvancedSelection();
  const hasFontSizeModifier = view.verifiers.hasResponsiveClass({
    element: selection.focusNode.parentElement,
    className: TEXT,
  });
  const hasTextIndentModifier = selection.focusNode.parentElement.closest(
    `[class^='${TEXT_INTENT_MODIFIER_PREFIX}']`
  );

  if (selection.isCollapsed && !hasFontSizeModifier && !hasTextIndentModifier) {
    return false;
  }

  if (settings.clearRestrictedParentsSelector) {
    if (element.closest(settings.clearRestrictedParentsSelector)) return false;
  }

  return element.matches(settings.clearQuerySelector);
};

export default shouldShowClearTrigger;
